import { useState, useEffect, useRef } from 'react'
import { getUserAgent } from '@sainsburys-tech/boltui-utils'

const testArSupported = () => {
  try {
    const ar = document.createElement('a')
    return ar.relList.supports('ar')
  } catch (error) {
    return false
  }
}

const testModelFormat = model => model && model.substring(model.length - 4) === 'usdz'

const getIOSversion = userAgent => {
  // test iOS version
  const osRegex = new RegExp(/iP(hone|od|ad);\sCPU\siPhone?\sOS\s\d+_\d*(_2)?/)
  const testOS = osRegex.exec(userAgent)
  const osDetails = testOS && testOS[0].split(' ')
  const version = osDetails && osDetails[4] && parseFloat(osDetails[4].replace('_', '.'))
  return testOS ? version : ''
}

const isiOSARCompatible = userAgent => {
  const { name, os } = userAgent
  return name === 'ios' && getIOSversion(navigator.userAgent) >= 12.2 && os === 'iOS' && testArSupported()
}

const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function useDevice(props) {
  const { partNumber, model } = props
  const userAgent = getUserAgent()
  const isAndroidChrome = userAgent.name === 'chrome' && userAgent.os === 'Android OS'
  const iosARCompatible = isiOSARCompatible(userAgent) && testModelFormat(model)

  const [only3DViewer, setOnly3DViewer] = useState(false)
  const prevPartNumber = usePrevious(partNumber)

  useEffect(() => {
    if (partNumber !== prevPartNumber) {
      setOnly3DViewer(false)
    }
    if (window.location.href.indexOf('#no-ar') > -1) {
      setOnly3DViewer(true)
      sessionStorage.setItem('ar', 'no')
    }
  })

  return { only3DViewer, isAndroidChrome, iosARCompatible }
}

export default useDevice
